module.exports = __webpack_public_path__ + "static/media/xrp.1c6c16bf.svg";